import { useAppSelector } from 'flow/hooks/useRedux';
import {
    selectKeysWaitingQueueItems,
    selectWaitingQueueItem,
} from 'flow/selectors/queue-selectors';
import { QueueCallQueueKey, QueueKey } from 'flow/types/EntityKeys';
import PbxIncomingCallItem from 'flow/components/pbx/PbxIncomingCallItem';
import EmptyStateQueueItemsWaiting from './EmptyStateQueueItemsWaiting';

interface Props {
    queueKey: QueueKey;
}

const QueueItemsWaiting = ({ queueKey }: Props) => {
    const waitingKeys = useAppSelector((state) =>
        selectKeysWaitingQueueItems(state, queueKey),
    );

    if (!waitingKeys?.size)
        return <EmptyStateQueueItemsWaiting queueKey={queueKey} />;

    return (
        <>
            {waitingKeys.toArray().map((key, index) => (
                <WaitingQueueItem
                    key={key}
                    queueCallKey={key}
                    queuePosition={index + 1}
                />
            ))}
        </>
    );
};

export default QueueItemsWaiting;

const WaitingQueueItem = ({
    queueCallKey,
    queuePosition,
}: {
    queueCallKey: QueueCallQueueKey;
    queuePosition: number;
}) => {
    const queueItem = useAppSelector((state) =>
        selectWaitingQueueItem(state, queueCallKey),
    );

    if (!queueItem?.get('key')) return null;

    return (
        <div>
            <PbxIncomingCallItem
                queueItem={queueItem}
                queuePosition={queuePosition}
            />
        </div>
    );
};
